export const CRSEvalMasterSelector = ({ crsevalmaster }) => crsevalmaster;
